import React, { useState, useEffect, useCallback } from 'react';
import { Divider } from 'rsuite';
import moment from 'moment';
import { useSelector,  connect} from 'react-redux';
import {getVehicleMakes, getVehicleModel}  from '../../../../app/common/services/fetch.service';
import {validateMappedRegValuesFull, isCyrilicFound, isLatinFound} from '../../../../app/common/services/vehicle.service';
import * as actionsPolicy  from '../../../../app/actions/policy';
import * as actionsAuth  from '../../../../app/actions/auth/auth';
import { NuInsInputTextLabel, NuInsInputNumLabel, NuInsSelectLabel, NuInsInputDateLabel } from '../elements/inputFieldsLabel';
import NuInsStepper from '../elements/NuInsStepper';
import {steppLabels} from './common/types';
import {fuelType as fuelTypes} from '../../../../app/common/types/vehicleTypes';
import {BackIcon} from '../svg/iconsSvg'

const MissingRegFields = ({onForward, onBack, updateRegProps, style}) => {
    const insCompanies = useSelector(state => state.insCompanies);
    const {registrationProps, initialData} = useSelector(state => state.insVehicleInfo);
    const {registered} = initialData || {};
    const questions = useSelector(state => state.questionsPolicy);
    const {vehicleType} = questions;
    const [formValid, setFormValid] = useState(false);
    const [checkFields, setCheckFields] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [vehicleMakes, setVehicleMakes] = useState([]);
    const [updatedMake, setUpdatedMake] = useState(true);
    const [vehicleModels, setVehicleModels] = useState([]);
    const {make, model, vin, color, fuelType, firstRegDate, maxPower, engineCapacity, seatsCount, weightF1, weightG} = registrationProps || {} ;
    const [requiredFields, setRequiredFields] = useState({make, model, vin, color, fuelType, firstRegDate, maxPower, engineCapacity, seatsCount, weightF1, weightG})
    const fuelTypeOptions = Object.keys(fuelTypes).map(type => ({label: fuelTypes[type], value: type, role: "Master"}));
    
    const errorMsg = "Полето е задължително";

    const fetchVehicleMakes = useCallback(() => {
        //use questions vehicheType here ...
        const type = registrationProps?.registrationType?.value ? registrationProps.registrationType?.value : 1;
            getVehicleMakes(type).then(
                (res) => {
                    if(res && res.data?.payload) {
                        const makes = res.data?.payload.map(value => ({label: value, value, role: "Master"}))
                        setVehicleMakes(makes);
                    }
                }, (error) => {console.log(error)}
            )
        }, [registrationProps]
    )    

    const fetchVehicleModel = useCallback(() => {
        const type = registrationProps?.registrationType?.value ? registrationProps?.registrationType?.value : 1;
            getVehicleModel(type, (requiredFields.make?.value)).then(
                (res) => {
                    if(res && res.data?.payload) {
                        let model = res.data?.payload.filter((value, index, self) => self.indexOf(value) === index) 
                        model = model.map(value => ({label: value, value, role: "Master"}))
                       setVehicleModels(model);
                    }
                }, (error) => {console.log(error)}
            )
        }, [registrationProps, requiredFields]
    )

    const validateFields = useCallback(() => {
            const {make, model, vin, color, fuelType, firstRegDate, maxPower,engineCapacity, seatsCount, weightF1, weightG} = requiredFields;

            if(vehicleType === '8' || vehicleType === '9') {
                if(make?.value && model?.value && vin?.value && color?.value && firstRegDate?.value && weightF1?.value && weightG?.value) {
                    setFormValid(true);
                    return;
                }
            } else if (requiredFields['fuelType']?.value === '4') {
                if(make?.value && model?.value && vin?.value && color?.value && fuelType?.value && firstRegDate?.value && maxPower?.value && seatsCount?.value && weightF1?.value && weightG?.value) {
                    setFormValid(true);
                    return;
                }
            } else {
                if(make?.value && model?.value && vin?.value && color?.value && fuelType?.value && firstRegDate?.value && maxPower?.value && engineCapacity?.value && seatsCount?.value && weightF1?.value && weightG?.value) {
                    setFormValid(true);
                    return;
                }
            }
            
            setFormValid(false);
        }, [requiredFields, vehicleType]
    )

    useEffect(() => {

        if(!vehicleMakes.length) {
            fetchVehicleMakes();
        }
        if(requiredFields.make?.value && updatedMake) {
            fetchVehicleModel();
            setUpdatedMake(false)
        }

        validateFields();
        
 //     console.log(requiredFields)

    }, [ requiredFields, vehicleMakes, updatedMake,
        fetchVehicleMakes, fetchVehicleModel, validateFields]);

    useEffect(() => {

        if(submitted && formValid && registrationProps && validateMappedRegValuesFull(registrationProps, vehicleType)) {

        //   console.log('requiredFields', requiredFields)

            onForward(4);

            setSubmitted(false);
        }

    }, [registrationProps, insCompanies, formValid, vehicleType, submitted, onForward]);
   
    const makeChangeHandler = (data) => {
        setUpdatedMake(true);
        setRequiredFields({...requiredFields, make: {value: data, userValue: data}, model: {}});
    } 

    const modelChangeHandler = (data) => setRequiredFields({...requiredFields, model: {value: data, userValue: data}});

    const vinChangeHandler = (data) => setRequiredFields({...requiredFields, vin: {value: data, userValue: data}});

    const colorChangeHandler = (data) => setRequiredFields({...requiredFields, color: {value: data, userValue: data}});

    const dateChangeHandler = (data) => {
        const newDate = data ? moment(data).format('YYYY-MM-DD') : null;
        setRequiredFields({...requiredFields, firstRegDate: {value: newDate, userValue: newDate}});
    }
    const fuelTypeChangeHandler = (data) => setRequiredFields({...requiredFields, fuelType: {value: data, userValue: fuelTypes[data], valueVIns: data}});

    const maxPowerChangeHandler = (data) => setRequiredFields({...requiredFields, maxPower: {value: data, userValue: data}});

    const engineCapacityChangeHandler = (data) => setRequiredFields({...requiredFields, engineCapacity: {value: data, userValue: data}});

    const seatsCountChangeHandler = (data) => setRequiredFields({...requiredFields, seatsCount: {value: data, userValue: data}});

    const weightF1ChangeHandler = (data) => setRequiredFields({...requiredFields, weightF1: {value: data, userValue: data}});

    const weightGChangeHandler = (data) => setRequiredFields({...requiredFields, weightG: {value: data, userValue: data}});

    const onBlurHandler = (field) => {
        setCheckFields({...checkFields, [field]: true});
    }

    const goBack = () => onBack(2);
    
    const submitHandler = (event) =>{
        event.preventDefault()
        if(!formValid && !registered ) {
            const inputFields = ['make', 'model', 'vin', 'color', 'firstRegDate', 'fuelType', 'maxPower', 'engineCapacity', 'seatsCount', 'weightF1', 'weightG'];
            const checkedFields = inputFields.reduce((acc, field) => ({...acc, [field]: true}) , {});
            setCheckFields(checkedFields);
            return;
        }

        if(formValid){
            const updatedRegProps = {...registrationProps, ...requiredFields} 

            updateRegProps(updatedRegProps); //updates registrationProps state in redux

            setTimeout(() => setSubmitted(true), 0);
        }
    }

    const checkForError = (field, type, allFields) =>  {
        switch (type) {
            case 'latin': {
                const noError = requiredFields[field]?.value && !isCyrilicFound(requiredFields[field]?.value)
                if (registered) {
                    return noError ? false : true;
                } 
                
                return (checkFields[field] && noError) || !checkFields[field] ? false : true;
            }
            case 'cyrillic': {
                const noError = requiredFields[field]?.value && !isLatinFound(requiredFields[field]?.value)
                if (registered) {
                    return noError ? false : true;
                } 
                
                return (checkFields[field] && noError) || !checkFields[field] ? false : true;
            }

            default: {
                if (registered) {
                    return requiredFields[field]?.value ? false : true;
                } 
                
                return (checkFields[field] && requiredFields[field]?.value) || !checkFields[field] ? false : true;
            }
        }
    }

    const generateErrorMsg = (field, type) => {
        switch (type) {
            case 'latin':
                return `${errorMsg} ${(requiredFields[field]?.value && isCyrilicFound(requiredFields[field]?.value)) ? 'на латиница' : ''}`;
            case 'cyrillic':
                return `${errorMsg} ${(requiredFields[field]?.value && isLatinFound(requiredFields[field]?.value)) ? 'на кирилица' : ''}`;
            default:
                return errorMsg;
        }
    }

    const checkForErrorNoZero = (field) => {
        if (registered) {
            return (requiredFields[field]?.value && parseInt(requiredFields[field]?.value) !== 0 ) ? false : true;
        } 
        
        return (checkFields[field] && requiredFields[field]?.value && parseInt(requiredFields[field]?.value) !== 0 ) || !checkFields[field]  ? false : true;
    }



    return(
        <div className="steps_container" style={style}>
            <div className="head" style={{paddingTop: '0', marginBottom: '-18px'}}>
                <div className="head-icon" style={{margin: '0 -8px 0 4px'}} onClick={goBack}><BackIcon size={32}/></div>
                <NuInsStepper activeStep={1} steps={4} labels={steppLabels}/>              
            </div>
            <Divider />                   
            <NuInsSelectLabel onChange={makeChangeHandler} onBlur={()=>onBlurHandler('make')} styles={{marginBottom: '20px'}}
                placeholder={"Марка (D1)"} 
                options={vehicleMakes} 
                value={vehicleMakes.length ? requiredFields.make?.value : null} 
                error={checkForError('make')} 
                errorMsg={errorMsg}/>
                          
            <NuInsSelectLabel onChange={modelChangeHandler} onBlur={()=>onBlurHandler('model')} styles={{marginBottom: '20px'}}
                placeholder={"Модел (D1)"} 
                options={vehicleModels} 
                value={vehicleModels.length ? requiredFields.model?.value : null} 
                error={checkForError('model')} 
                errorMsg={errorMsg}/>
                          
            <NuInsInputTextLabel onChange={vinChangeHandler} onBlur={()=>onBlurHandler('vin')} styles={{marginBottom: '20px'}}    
                slice={17}
                placeholder={"Рама (E)"}
                value={requiredFields.vin?.value}
                error={checkForError('vin', 'latin')}  
                errorMsg={generateErrorMsg('vin','latin')}/>
                     
            <NuInsInputTextLabel onChange={colorChangeHandler} onBlur={()=>onBlurHandler('color')}  styles={{marginBottom: '20px'}}
                placeholder={"Цвят (R)"} 
                value={requiredFields.color?.value} 
                error={checkForError('color', 'cyrillic')} 
                errorMsg={generateErrorMsg('color','cyrillic')}/>
                   
            <NuInsInputDateLabel onChange={dateChangeHandler} 
                placeholder={"Дата на първа регистрация (В)"} 
                value={requiredFields.firstRegDate?.value ? new Date(requiredFields.firstRegDate?.value) : null} 
                error={checkForError('firstRegDate')} 
                errorMsg={errorMsg}/>
            
            {(vehicleType !== '8' && vehicleType !== '9')
                ? <>
                <NuInsSelectLabel onChange={fuelTypeChangeHandler} onBlur={()=>onBlurHandler('fuelType')} styles={{marginBottom: '20px', marginTop: '20px'}}
                    placeholder={"Гориво (P.3)"} 
                    options={fuelTypeOptions} 
                    value={requiredFields.fuelType?.value} 
                    error={checkForError('fuelType')} 
                    errorMsg={errorMsg}/>
                     
                <NuInsInputNumLabel onChange={maxPowerChangeHandler} onBlur={()=>onBlurHandler('maxPower')} styles={{marginBottom: '20px'}}
                    validationType={"noZero"} 
                    slice={4} 
                    placeholder={"Мощност (P.2) kW"} 
                    value={requiredFields.maxPower?.value} 
                    error={checkForErrorNoZero('maxPower')} 
                    errorMsg={errorMsg}/>

                    {((requiredFields['fuelType']?.value !== '4') && registered ) || (!registered && vehicleType !== '2' )
                    ? (<> <NuInsInputNumLabel onChange={engineCapacityChangeHandler} onBlur={()=>onBlurHandler('engineCapacity')} styles={{marginBottom: '20px'}}
                            validationType={"noZero"} 
                            slice={4}
                            placeholder={"Обем на двигателя (P.1) куб. см"} 
                            value={requiredFields.engineCapacity?.value} 
                            error={checkForErrorNoZero('engineCapacity')} 
                            errorMsg={errorMsg}/>
                     </>)
                    : null }                   
                <NuInsInputNumLabel onChange={seatsCountChangeHandler} onBlur={()=>onBlurHandler('seatsCount')} 
                    slice={2}
                    placeholder={"Брой места (S.1)"} 
                    value={requiredFields.seatsCount?.value} 
                    error={checkForError('seatsCount') } 
                    errorMsg={errorMsg}/>
                </>
                : null }
                
            <NuInsInputNumLabel onChange={weightF1ChangeHandler} onBlur={()=>onBlurHandler('weightF1')} styles={{marginBottom: '20px', marginTop: '20px'}}
                validationType={"noZero"}
                placeholder={"Технически допустима макс. маса (F.1)"} 
                value={requiredFields.weightF1?.value} 
                error={checkForErrorNoZero('weightF1') } 
                errorMsg={errorMsg}/>
                   
            <NuInsInputNumLabel onChange={weightGChangeHandler} onBlur={()=>onBlurHandler('weightG')}
                validationType={"noZero"}
                placeholder={"Маса на превозното средство (G)"} 
                value={requiredFields.weightG?.value} 
                error={checkForErrorNoZero('weightG')} 
                errorMsg={errorMsg}/>

            <button className="nuIns-btn nuIns-btn-main nuIns-btn-mx" type="submit" disabled={!formValid && registered} onClick={submitHandler}>Продължи</button>

        </div>
    )
}

export default connect(null, {...actionsPolicy, ...actionsAuth})(MissingRegFields);

